import(/* webpackMode: "eager" */ "/vercel/path0/src/app/customizer/page.tsx");
